let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("i3L0u")]).then(() => parcelRequire('8Xvm1'));